import React from 'react';

import Block from './block';
import Title from './my-title';

const BlockContentImage = (imageUrl, imageAlt) => (
  <div className="decoration">
    <img className="w-100 img-fluid block-content-image" src={imageUrl} alt={imageAlt} />
  </div>
)

const BlockContentText = (children) => (
  <div className="block-content">
    {children}
  </div>
)

const BlockContent = ({ backgroundUrl, imageUrl, imageAlt, title, reverse = false, hasDecoration, children }) => (
  <Block backgroundUrl={backgroundUrl} hasDecoration={hasDecoration}>
    <div className="block-content">
      {title ? (
        <div className="row">
          <div className="col-12">
            <Title>{title}</Title>
          </div>
        </div>
      ): null}
      {reverse ? (
        <div className="row">
          <div className="col-lg-5 mb-5">
            {BlockContentText(children)}
          </div>
          <div className="col-lg-7">
            {BlockContentImage(imageUrl, imageAlt)}
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-7 mb-5">
            {BlockContentImage(imageUrl, imageAlt)}
          </div>
          <div className="col-lg-5">
            {BlockContentText(children)}
          </div>
        </div>
      )}
    </div>
  </Block>
)

export default BlockContent;



// WEBPACK FOOTER //
// ./src/components/block-content.js